import type { PlayerDto } from '@poker-stats/contracts';
import AutocompletePlayerModel from '../../viewModel/AutocompletePlayerModel';

export const pokerSitePostfix: { [key in 1 | 2 | 3 | 4 | 5 | 6]: string } = {
  1: 'PS',
  2: 'CHI',
  3: 'WPN',
  4: '888',
  5: 'CPR',
  6: 'IP',
};

export function getPokersiteIdByPokersiteName(name: string) {
  if (name === 'ps') {
    return 1;
  }

  if (name === 'chi') {
    return 2;
  }

  if (name === 'wpn') {
    return 3;
  }

  if (name === '888') {
    return 4;
  }

  if (name === 'CPR') {
    return 5;
  }

  if (name === 'IP') {
    return 6;
  }

  return undefined;
}

export function getPokersiteNameByPokersiteId(id: 1 | 2 | 3 | 4 | 5 | 6) {
  if (id === 1) {
    return 'ps';
  }

  if (id === 2) {
    return 'chi';
  }

  if (id === 3) {
    return 'wpn';
  }

  if (id === 4) {
    return '888';
  }

  if (id === 5) {
    return 'CPR';
  }

  if (id === 6) {
    return 'IP';
  }

  return 'ps';
}

export function getPlayerStatsHref(playername: string, pokersiteId: 1 | 2 | 3 | 4 | 5 | 6) {
  const querystring = new URLSearchParams({
    playername,
    room: getPokersiteNameByPokersiteId(pokersiteId),
  });

  return `/statistics?${querystring.toString()}`;
}

export function prepareLoadedPlayers(players: Array<PlayerDto>): Array<AutocompletePlayerModel> {
  return players.map((x) => ({
    id: x.id,
    playername: x.playername,
    pokersiteId: x.pokersite_id,
    label: `${x.playername} (${pokerSitePostfix[x.pokersite_id]})`,
  }));
}

export function isFishPlayer(vpip: number | null | undefined) {
  return vpip != null && vpip > 40;
}

export function isRegularPlayer(
  hands: number | null | undefined,
  bb100: number | null | undefined,
  vpip: number | null | undefined,
  pfr: number | null | undefined,
) {
  const handsCount = hands ?? 0;

  const isVolumeWinner = handsCount > 30000 && (bb100 ?? 0) > 0;

  const isTightRegular =
    handsCount > 30 &&
    vpip != null &&
    vpip >= 12 &&
    vpip <= 28 &&
    pfr != null &&
    pfr >= 10 &&
    pfr <= 24;

  return isVolumeWinner || isTightRegular;
}

export function isPhoneStationPlayer(
  hands: number | null | undefined,
  wtsd: number | null | undefined,
) {
  return (hands ?? 0) > 800 && wtsd != null && wtsd > 35;
}

export function getPortablePlayerBadgeType(
  hands: number | null | undefined,
  bb100: number | null | undefined,
  vpip: number | null | undefined,
  pfr: number | null | undefined,
): 'fish' | 'reg' | null {
  const isFish = isFishPlayer(vpip);
  const isReg = isRegularPlayer(hands, bb100, vpip, pfr);

  if (isFish && isReg) {
    return 'fish';
  }

  if (isFish) {
    return 'fish';
  }

  if (isReg) {
    return 'reg';
  }

  return null;
}
